import React, { FC } from 'react';
import { Switch as BaseSwitch, SwitchProps } from '@chakra-ui/react';

const Switch: FC<SwitchProps> = props => {
  return <BaseSwitch {...props} colorScheme="pink" />;
};

export default Switch;
